import { render, staticRenderFns } from "./news_det.vue?vue&type=template&id=7f75f0d6&scoped=true&"
import script from "./news_det.vue?vue&type=script&lang=js&"
export * from "./news_det.vue?vue&type=script&lang=js&"
import style0 from "./news_det.vue?vue&type=style&index=0&id=7f75f0d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f75f0d6",
  null
  
)

export default component.exports